import React from 'react';
import { getEnvironment } from '@global/helpers';

import SociollaGoogleMaps from '@components/sociolla/SociollaGoogleMaps';
import SociollaOpenStreetMaps from '@components/sociolla/SociollaOpenStreetMaps';

const Config = getEnvironment();

function MapPicker(props) {
  if (Config.MAP === 'google') {
    return <SociollaGoogleMaps {...props} />;
  } else if (Config.MAP === 'osm') {
    return <SociollaOpenStreetMaps {...props} />;
  }
  return false;
}

export default React.memo(MapPicker, (prev, next) => prev == next);
